module.exports = __webpack_public_path__ + "static/media/scalpel.2d4c3cb8.svg";